export default __webpack_public_path__ + "static/media/gb-luvas.7a8f7138.png";